<template>
  <div>
    <div class="top">
      <Breadcrumb :options="breadcrumb" />
      <Wxts :wxtsList="wxtsList" />
    </div>


    <el-form ref="form" :model="form" :rules="rules" :label-width="labelWidth">
      <FormItem v-for="(c, i) in formCtrl" :key="'formItem' + i" :viewMode="viewMode" :config="c" :options="c.options"
        :inputValue="form[c.keyName]" @onChange="onChange" />
    </el-form>

    <div class="btns">
      <el-button type="primary" @click="onSubmit">保 存</el-button>
    </div>
  </div>
</template>

<script>
import Wxts from '../../../components/Wxts.vue';
import detailMixin from "../../mixin/detail";

export default {
  components: { Wxts },
  name: "FinanceBaseSalary",
  mixins: [detailMixin],
  data() {
    return {
      baseUrl: 'Warning',
      breadcrumb: [
        { name: "系统设置" },
        { name: "预警阈值设置" },
      ],
      wxtsList: [
        {
          name:'超过该阈值即触发系统提醒。'
        },
        {
          name:'油气费占比=油气费合计/运费总额。'
        },
        {
          name:'费用合计占比=（出车费用+附加费用）/运费总额。'
        },
      ],
      rules: {
        fuel: [
          { required: true, validator: this.checkPercent, trigger: "blur" },
        ],
        cost: [
          { required: true, validator: this.checkPercent, trigger: "blur" },
        ],
        overspeed: [
          { required: true, validator: this.checkSpeed, trigger: "blur" },
        ],
      },
      formCtrl: [
        {
          label: "油气费占比",
          keyName: "fuel",
          err: "请填写油气费占比",
          type: "number",
          unit: "%",
          tips: "超过该比例触发预警",
        },
        {
          label: "费用合计占比",
          keyName: "cost",
          err: "请填写费用合计占比",
          type: "number",
          unit: "%",
          tips: "超过该比例触发预警",
        },
        {
          label: "超速预警",
          keyName: "overspeed",
          err: "请填写超速预警",
          type: "number",
          unit: "km/h",
          tips: "超过该数值触发预警",
        },
      ],
    };
  },
  methods: {
    checkPercent(rule, value, callback) {
      // console.log(rule, value)
      // console.log(Number(value))
      // console.log(Number(value) > 60)
      // if (value == undefined || value == '') {
      //   callback(new Error('请确认密码'));
      // } else
      if (Number(value) > 99 || Number(value) < 1) {
        // callback(new Error('该比例应处于1%-99%之间'));
        this.$message({
          type: 'error',
          message: '该比例应处于1%-99%之间！',
        });
        callback(new Error(' '));
      } else {
        callback();
      }
    },
    checkSpeed(rule, value, callback) {
      // console.log(rule, value)
      // console.log(Number(value))
      // console.log(Number(value) > 60)
      // if (value == undefined || value == '') {
      //   callback(new Error('请确认密码'));
      // } else
      if (Number(value) > 99 || Number(value) < 1) {
        this.$message({
          type: 'error',
          message: '该数值应大于1！',
        });
        callback(new Error(' '));
      } else {
        callback();
      }
    },
    getData() {
      this.loading = true
      let url = `${this.baseUrl}/index`;
      const params = {
        userid: this.user.id,
      }
      this.post(url, params, ({ msg, data }) => {
        if (msg === 'success' && data) {
          this.detail = data
          this.formCtrl.map(v => {
            const key = v.keyName
            this.form[key] = this.detail[key];
          })
          this.$forceUpdate()
          // console.log({ ...this.detail })
          // console.log({ ...this.form })
        } else {
          this.$message({
            type: 'error',
            message: '加载失败，请稍后再试！',
          });
        }
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    onSubmit() {
      console.log({ ...this.form });
      this.$confirm('确认提交吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(this.submitReq).catch(() => { });
    },
    submitReq() {
      this.loading = true
      let url = `${this.baseUrl}/addedu`;
      const params = {
        // userid: this.user.id,
      }
      const object = this.form
      for (const key in object) {
        if (Object.hasOwnProperty.call(object, key)) {
          params[key] = object[key];
        }
      }
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '提交成功!',
          });
          this.getData()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交失败，请稍后重试！'
        });
      })
    },
  },
  mounted() {
    this.getData()
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-form {
  background-color: #fff;
  padding-top: 20px;
  border-radius: 5px;
  box-shadow: 0px 0px 10px rgb(0 0 0 / 3%);

  .el-form-item {
    border-bottom: 1px solid #f2f6fc;
    padding: 0 20px 15px 0;

    .tips {
      margin: 10px auto 0;
    }

    .el-input {
      width: 200px;
    }
  }

  // .el-textarea {
  //   width: 200px;
  // }
}

.btns {
  margin: 40px 0 60px 180px;
}

.top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 20px;
}
</style>
